import { render, staticRenderFns } from "./UseCaseCard.vue?vue&type=template&id=5c8d8b86&scoped=true&"
import script from "./UseCaseCard.vue?vue&type=script&lang=js&"
export * from "./UseCaseCard.vue?vue&type=script&lang=js&"
import style0 from "./UseCaseCard.vue?vue&type=style&index=0&id=5c8d8b86&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c8d8b86",
  null
  
)

export default component.exports